import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import { jsx as _jsx } from "react/jsx-runtime";
const styles = {
  grid: {
    position: "relative",
    width: "100%",
    minHeight: "1px",
    paddingRight: "15px",
    paddingLeft: "15px"
    /* flexBasis: "auto" */
  }
};
const useStyles = makeStyles(styles);
export default function GridItem(props) {
  const {
    children,
    className = "",
    xs,
    sm,
    md,
    lg,
    xl,
    size,
    ...rest
  } = props;
  const classes = useStyles();
  const responsiveSize = {
    ...(xs !== undefined ? {
      xs
    } : {}),
    ...(sm !== undefined ? {
      sm
    } : {}),
    ...(md !== undefined ? {
      md
    } : {}),
    ...(lg !== undefined ? {
      lg
    } : {}),
    ...(xl !== undefined ? {
      xl
    } : {})
  };
  const mergedSize = size !== undefined ? size : Object.keys(responsiveSize).length ? responsiveSize : undefined;
  return /*#__PURE__*/_jsx(Grid, {
    ...rest,
    size: mergedSize,
    className: classes.grid + " " + className,
    children: children
  });
}